import {
  FAQS,
  TERMS_AND_CONDITION,
  REGISTRATION_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const northwestarkansasnaturals_pass: TTeamConfig = {
  TEAM_SCHEMA: "northwestarkansasnaturals_pass",
  TEAM_FULL_NAME: "Northwest Arkansas Naturals",
  BROWSER_TITLE: "Northwest Arkansas Naturals All Access Pass",
  CLIENT_ID: "0UUFMFyx1HG3uTR4P9lxUReKmhDdgJf2uYLlRYczJgBb55f3",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#00539f",
    COLORS_SECONDARY: "#ffffff",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    ACCOUNT_MANAGER_URL:
      "https://www.milb.com/northwest-arkansas/tickets/my-naturals-tickets",

    FOOTER: {
      BACKGROUND_COLOR: "#00539f",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      SHOW_FAQ_BUTTON: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#00539f",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Northwest%20Arkansas%20Naturals/arkansas-naturals-logo.webp",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Northwest%20Arkansas%20Naturals/arkansas-naturals-background.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
